import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popover from 'material-ui/Popover';

import Button from '../../Button';
import Icon from '../../Icon';

import Info from './Info';

const InfoBtn = ({ iconName, size, value }) => {
  const [isPopoverOpened, togglePopover] = useState(false);
  const [anchorEl, setAnchorEl] = useState();

  const handleTouchTap = e => {
    e.preventDefault();

    togglePopover(true);
    setAnchorEl(e.currentTarget);
  };

  const handleRequestClose = () => {
    togglePopover(false);
  };

  return (
    <div>
      <Button icon onClick={handleTouchTap}>
        <Icon name={iconName} size={size} />
      </Button>
      <Popover
        className="popover"
        open={isPopoverOpened}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        onClose={handleRequestClose}
      >
        <Info value={value} />
      </Popover>
    </div>
  );
};

InfoBtn.propTypes = {
  iconName: PropTypes.string,
  size: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

InfoBtn.defaultProps = {
  iconName: 'info',
  size: 22,
};

export default InfoBtn;



// WEBPACK FOOTER //
// ./src/components/common/InfoBtn/index.jsx